<template>
  <div class="work">
    <!-- <router-view/> -->
    <headerCom>
      <!-- <h1 class="font-size18 black-font" v-if="selectids.length<1">{{draftinfo.name}}</h1> -->
      <div class="flex-lm" slot="act">
        <div class="work-acts flex-lm white-font font-size14">
          <!--
          <div class="flex-cm work-act-single white-font font-size14" style="position: relative;" @mouseenter="showgroup" @mouseleave="hidegroup">
              <div class="bg-green botton-content flex-cm">
                <img src="https://assets.pfotoo.com/pc/img/addphoto.svg" style="width: 14px;height: 14px;margin-right: 5px;"/>
                <span class="">添加到相册</span>
              </div>
              <group :cid="draftinfo.id" :show="addshow" v-if="draftinfo.id" :id="workidstr"></group>
            </div>
            <!-- <div class="flex-cm work-act-single white-font font-size14" @click="delwork">
              <div class="bg-green botton-content flex-cm only-click-button">
                <img src="https://assets.pfotoo.com/pc/img/move.svg" style="width: 14px;height: 14px;margin-right: 5px;"/>
                <span>批量移动</span>
              </div>
           </div> -->
          <div class="flex-cm work-act-single white-font font-size14" @click="showhidework(1)">
            <div class="bg-green botton-content flex-cm only-click-button">
              <img src="https://assets.pfotoo.com/pc/img/hide.svg" style="width: 14px;height: 14px;margin-right: 5px;"/>
              <span>批量隐藏</span>
            </div>
          </div>
            <div class="flex-cm work-act-single white-font font-size14" @click="delwork">
              <div class="bg-green botton-content flex-cm only-click-button">
                <img src="https://assets.pfotoo.com/pc/img/delete.svg" style="width: 16px;height: 16px;"/>
                <span>批量删除</span>
              </div>
            </div>
          <div class="flex-cm work-act-single white-font font-size14" @click="showhidework(0)">
            <div class="bg-green botton-content flex-cm only-click-button">
              <img src="https://assets.pfotoo.com/see-show.svg" style="width: 14px;height: 14px;margin-right: 5px;"/>
              <span>取消隐藏</span>
            </div>
          </div>
          <!--
            <div class="flex-cm work-act-single white-font font-size14" @click="downall">
              <div class="bg-green botton-content flex-cm only-click-button">
                <img src="https://assets.pfotoo.com/pc/img/downall.svg" style="width: 14px;height: 14px;margin-right: 5px;"/>
                <span>下载全部</span>
              </div>
            </div>
            -->
        </div>
      </div>
      <div class="search flex-lm" slot="search">
        <input placeholder="搜索" class="search-input" @focus="changefoucusval" @blur="changefoucusval" :style="{'width':searchval!='' || inputfocus==true ? 195+'px' : 100+'px',}" v-model="searchval" @keyup.enter="search"/>
        <div class="search-button flex-vc" @click="search">
          <i class="el-icon-search"></i>
        </div>
      </div>
    </headerCom>
    <!-- 内容content -->
    <div class="bg-white" :style="{minHeight:minHeight+'px'}" @click="changeshowlist">
      <div class="detail-top">
        <div class="font-size14 gray-font flex-lr detail-active-title">
          <div class="flex-cm">
            <div style="cursor: pointer;" @click.stop="back">活动管理</div>
            &nbsp;&nbsp;>&nbsp;&nbsp;
            <span class="black-font">{{draftinfo.name}}</span>
          </div>
          <div class="flex-rr" @click.stop="selectall" style="width: 60px;height: 28px;">
            <div :class="['checkbox flex-cm',allselect ? 'bg-green' : '']">
              <img src="https://assets.pfotoo.com/pc/img/right-white.svg" style="width:20px;height:20px;margin-left:-1px;position: relative;" v-if="allselect"/>
            </div>
            <div class="black-font font-size14">全选</div>
          </div>
        </div>
        <div class="table-total flex-lr bg-light-gray black-font font-size12">
          <optionPlane ref="optionPlane" :draftinfo="draftinfo"
                       v-if="draftinfo.activityId" @event="optionPlaneEvent"></optionPlane>
          <div class="font-size14 gray-font smooth">筛选出{{total}}个投稿</div>
        </div>
      </div>
      <!-- 作品 -->
      <div class="detail-content flex-rs" v-if="showlist && showlist.length>0" style="box-sizing: border-box;">
        <work v-for="(item,index) in showlist" ref="work"
              :key="index" :item="item" :index="index"
              v-on:tellworkidx="showbigimages" v-on:selectwork="selectsingle"
              v-on:del="refresh" v-on:editmodal="editaction"
              :type="(draftinfo.type ? draftinfo.type : 1)/1"></work>
      </div>
      <div class="flex-vc" :style="{minHeight:minHeight-200+'px'}" v-else>
        <img src="https://assets.pfotoo.com/pc/img/nothing.svg"/>
        <div class="gray-font font-size14" style="padding: 10px 0px 20px;">暂无征稿</div>
        <div class="green-font font-size14 flex-cm" style="width: 130px; height: 30px; border-radius: 15px; border: 1px solid rgb(61, 196, 167); cursor: pointer;" @click.stop="invite(id)">邀请投稿</div>
      </div>
      <!-- 邀请投稿 -->
      <div class="code-mask flex-cm fixed left right top bottom" :style="{'visibility':showcode}" @click.stop="closecode">
        <div :class="['code-content bg-white flex-vc',showcode=='visible' ? 'active' : '']">
          <div class="black-font font-size30 flex-cm font-bold">微信扫一扫</div>
          <img :src="code" class="invite-code"/>
          <div class="black-font font-size18 flex-cm">请使用“{{userinfo.name}}”的微信，邀请投稿</div>
          <img src="https://assets.pfotoo.com/icon/pc%E5%85%B3%E9%97%AD.svg" class="code-close" @click.stop="closecode"/>
        </div>
      </div>

      <!-- 查看大图 -->
      <div class="work-cover fixed left right top bottom" :style="{visibility: showcover,}" v-if="showimages.length>0">
        <div class="work-cover-top flex-lr">
          <div class="white-font font-size16 font-more" style="width: 80%; display: block;">{{showimages[showindex].name}}</div>
          <div class="flex-rr">
            <!-- <div class="download-icon flex-cm" style="cursor: pointer;padding:0 30px;">
              <img src="https://assets.pfotoo.com/icon/upload.svg"/>
              <wechat :id="showimages[showindex].id" :show="wechatshow" :uploadtype="showimages[showindex].exif.type ? (showimages[showindex].exif.type==2 ? 3 : 2) : (draftinfo.type==2 ? 3 : 2)"></wechat>
            </div> -->
            <a class="download-icon"
               @click.stop="downloadFile">
              <img src="https://assets.pfotoo.com/icon/pc%E4%B8%8B%E8%BD%BD.svg"/>
              <div class="white-font font-size14 flex-cm down-load-hover">{{draftinfo.type==4?'复制':'下载'}}</div>
            </a>
            <img src="https://assets.pfotoo.com/icon/pc%E5%85%B3%E9%97%AD.svg" style="margin-left:30px;" @click="close"/>
          </div>
        </div>
        <div id="swiper" class="swiper-container">
          <div class="swiper-wrapper pppp">
            <div class="swiper-slide flex-cm" v-for="(item,index) in showimages" :key="index" :style="{left:item.left,}">
              <template v-if="item.exif.type==1">
                <div class="swiper-bg"
                     :style="{background:'url('+item.comurl+') center center / contain no-repeat'}"></div>
              </template>
              <template v-else-if="item.exif.type==2">
                <video controls="controls" class="flex-cm" ref="video"
                       :id="'video'+item.id" :poster="item.comurl"
                       :src="item.url" :preload="index==showindex ? true : false"></video>
              </template>
              <template v-else-if="item.exif.type==3">
                <div class="swiper-bg flex-vc work-font-cover">
                  <div class="work-font-content white-font font-size18">{{item.exif.text}}</div>
                </div>
              </template>
              <template v-else-if="item.exif.type==4">
                <div class="swiper-bg flex-vc bg-gray">
                  <img :src="item.comurl" style="width: 120px;height: 120px;margin-bottom: 20px;"/>
                  <div class="black-font font-size20 font-more font-bold" style="width: 90%;text-align: center;opacity: .8;margin: 0 auto;">{{item.exif.name}}</div>
                </div>
              </template>
              <template v-else-if="item.exif.type==5">
                <div class="swiper-bg swiper-bg-audio">
                  <div class="audio-bg"
                       :style="{'background-image':'url('+item.comurl+')'}"></div>
                  <audio controls ref="audio" style="margin-top: 60px;" class="audio-play">
                    <source :src="item.url">
                    您的浏览器不支持 audio 元素。
                  </audio>
                </div>
              </template>
            </div>
          </div>
          <div class="swiper-button-prev swiper-button flex-cm" @click="previmage" :style="{visibility: showindex>0 && showcover!='hidden' ? 'visible' : 'hidden'}">
            <img src="https://assets.pfotoo.com/icon/pc%E5%B7%A6%E7%AE%AD%E5%A4%B4.svg"/>
          </div>
          <div class="swiper-button-next swiper-button flex-cm" @click="nextimage" :style="{visibility: showindex<showimages.length-1 && showcover!='hidden' ? 'visible' : 'hidden'}">
            <img src="https://assets.pfotoo.com/icon/pc%E5%8F%B3%E7%AE%AD%E5%A4%B4.svg"/>
          </div>
        </div>
      </div>
      <div class="detail-page bg-white">
        <el-pagination
                background
                layout="total,sizes,prev, pager, next"
                :total="total"
                @size-change="handleSizeChange"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                :current-page.sync="pageIndex"
                @current-change="handleCurrentChange">
        </el-pagination>
      </div>
      <proview ref="proview" :identityType="identityType" :draftinfo="draftinfo"></proview>

    </div>
  </div>

</template>

<script>
  import headerCom from '../header.vue'
  import group from '../group.vue'
  import tab from '../tab.vue'
  import work from '../work.vue'
  import App from '../../util/comfun'
  import proview from '../dialog/proview.vue'
  import optionPlane from "../dialog/option-plane.vue"
  export default {
    name: 'detail',
    data () {
      return {
        id:0,
        openid:JSON.parse(localStorage.getItem('userinfo')).openid,
        draftinfo:{},
        minHeight:window.innerHeight-82,
        listconfig:{
          'new':{
            page:1,
            loaded:false,
            end:false,
          }
        },
        pageIndex:1,
        pageSize:20,
        type:'new',
        showlist:[],
        allselect:false,
        selectids:[],
        strselectids:'',
        workidstr:'',
        showcode:'hidden',
        userinfo:JSON.parse(localStorage.getItem('userinfo')),
        unitlist:[],
        unit:'',
        code:'',
        showimages:[],
        showcover:'hidden',
        showindex:0,
        isRouterAlive:true,
        addshow:false,
        searchval:'',
        inputfocus:false,
        total:0,
        activeMaterialType:'',
        materialTypes:{
          Picture:'照片',
          Video:'视频',
          Audio:'音频',
          Word:'文字',
          Document:'文档',
        },
        activeTrackId:'',
        identityType:-1,//identityType 0创建，1管理，2协作
      }
    },
    // provide(){
    //   return {
    //     reload:this.reload
    //   }
    // },
    components:{
      headerCom,
      group,
      tab,
      work,
      proview,
      optionPlane,
    },
    methods:{
      resetList(hasFirstPage=true){
        this.selectids=[];
        this.allselect=false
        //this.total=0
        this.showlist=[]
        if(hasFirstPage){
          this.pageIndex=1
        }

      },
      getsign(){
        return this.$getsign();
      },
      changefoucusval(){
        this.inputfocus=!this.inputfocus;
        if(!this.inputfocus && this.searchval==''){
          this.resetList()
          this.getnewlist()
        }
      },
      search(){
        this.resetList()
        this.getnewlist()
      },
      getdetail(){

       this.$http({
         url:'https://pfotoo.com?s=App.Contribution.GetContributionById'+this.$getsign(),
         params:{
           id:this.id,
           openid:this.openid
         },
         method:'POST',
         headers: {
           'Content-Type': 'application/x-www-form-urlencoded'
         }
       }).then((json)=>{
         if(json.code==200){
           json.data.removead=json.data.activityAuth.isAdvertisement
           json.data.id=json.data.activityId
           json.data.name=json.data.activityName
           json.data.introduce=json.data.description
           json.data.images=json.data.activityCovers[0].url
           json.data.long_term=json.data.isLongTerm
           json.data.ispublic=json.data.visibleType//投稿可见类型 0：都可见 1：仅组织者可见
           json.data.iscomment=json.data.isComment//投稿作品评论（是否支持评论 1 是 0 否）
           json.data.type=App.metaKey(json.data.activityType,App.metaTypeHD)
           //附件
           json.data.is_enclosure=json.data.activityAuth.isAnnex
           json.data.enclosure_desc=json.data.activityAuth.enclosureTips
           //作品信息
           json.data.open_worksign=json.data.activityAuth.isAuthorName
           json.data.open_workdesc=json.data.activityAuth.isSubmissionDesp
           json.data.open_workname=json.data.activityAuth.isSubmissionName
           json.data.text=json.data.activityAuth.submissionTips
           //联系方式
           json.data.contacts_text=json.data.activityAuth.contactTips
           json.data.open_mail=json.data.activityAuth.isEmail
           json.data.open_phone=json.data.activityAuth.isMobile
           json.data.open_qq=json.data.activityAuth.isQq||0
           json.data.open_wechat=json.data.activityAuth.isWechat

           json.data.status=json.data.activityStatus==1?0:1
           //投稿要求
           json.data.other=json.data.activityAuth.submissionRequire||''
           //theme!='不限题材
           json.data.theme='不限题材'
           if(json.data.tagList.length>0){
             let theme=[];
             json.data.tagList.forEach(t=>{
               theme.push(t.name)
             })
             json.data.theme=theme.join(',')
           }
           //time
           json.data.stime=json.data.startTime
           json.data.etime=json.data.endTime
           json.data.close_time=json.data.deadlinesTime||''
           //console.log('rule',json.data.activityType,json.data.activityMaterialTypeRefs[0])
           if(json.data.activityMaterialTypeRefs && json.data.activityMaterialTypeRefs.length>0){
             let rule=json.data.activityMaterialTypeRefs[0]
             switch (json.data.activityType){
               case "Picture"://图片
                 json.data.filemax=rule.size
                 break;
               case "Video"://视频
                 json.data.filemax=rule.duration
                 break;
               case "PictureAndVideo"://图片+视频
                 json.data.filemax=rule.size+'-'+rule.duration
                 break;
               case "Word"://文字
                 json.data.filemax=rule.wordsCount
                 break;
               case "Document"://素材
                 json.data.filemax=rule.size
                 break;
             }
           }
           json.data.residualDownloadTraffic=0
           this.draftinfo=json.data
           this.getTrafficUser()
            if(json.data.theme!='不限题材'){
              let arr=json.data.theme.split(',');
              arr.forEach((v,i)=>{
                this.unitlist.push({
                  name:v,
                  isactive:false
                })
              })
            }
         }
       })
     },
      getTrafficUser(){
        App.demand('/user/info','GET',{
          userId:this.draftinfo.createBy,
        }).then(res=>{
          this.draftinfo.residualDownloadTraffic=res.data.residualDownloadTraffic/1
        })
      },
     showgroup(){
       console.log('uuuuuu')
       this.addshow=true;
       console.log(this.addshow)
     },
     hidegroup(){
       this.addshow=false;
     },
      //获得tagId
      getTagId(params) {
        console.info('getTagId', this.unit, this.draftinfo)
        if (this.unit && this.draftinfo.tagList) {
          this.draftinfo.tagList.some(t => {
            if (t.name == this.unit) {
              params.tagId = t.id
              return true
            }
          })
        }
        return params
      },
     getnewlist(){
       this.resetList(false)
       let loading=this.$loading({text:'loading...',target: '.down-content',})
       this.params.pageIndex=this.pageIndex
       this.params.pageSize=this.pageSize
       this.params.keyword=''
       if(this.searchval){
         this.params.keyword=this.searchval
       }
       App.Submission.List(this.params).then(json=>{
         setTimeout(()=>{loading.close();},0)
         if(json.code==200) {
           this.total=json.data.total;
           this.showlist=json.data.submissionInfoList
         }else{
           this.total=0;
           this.$message({
             showClose: true,
             message: json.message
           });
         }
       })
     },
     showhidework(status){
        if(this.selectids.length>0){
          if(status==0){
            //this.resetList(false)
            return this.sethidework(status);
          }
          this.$confirm('确定要隐藏所选择的作品吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            //this.resetList(false)
            this.sethidework(status);
          }).catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消'
            // });
          });
        }else{
          this.$message({
              showClose: true,
              message: '请选择要隐藏的作品'
          });
        }
     },
     getgrouplist(){
       let paramdata={
        id:this.listconfig[this.type].id,
        openid:this.openid,
        page:this.listconfig[this.type].page,
        size:10
       }
       if(this.unit!=''){
         paramdata.unit=this.unit
       }
       this.$http({
         url:'https://pfotoo.com?s=App.Contribution.GetGroupByWorks'+this.$getsign(),
         params:paramdata,
         method:'POST',
         headers: {
           'Content-Type': 'application/x-www-form-urlencoded'
         }
       }).then((res)=>{
         console.log(res.body)
         let json=res.body;
         if(res.body.ret==200){
            this.marklist(json.data);
         }
       })
     },
     marklist(json){
      if(json.length>0){
        json.forEach((v,i)=>{
//          if (v.status == 1) {
//            delete json[i]
//            return;
//          }
          v.type = this.draftinfo.type;
          v.likenum = Number(v.likenum);
          v.images = v.submissionMaterialList
          /*
          if(this.data.type=='like'){
            v.images=v.imageList;
          }
          */
          if (v.images.length > 0) {
            v.images.forEach((r, n) => {
              if (typeof r.exif == 'string') {
                //console.info('r.exif',r.exif)
                r.exif = JSON.parse(r.exif);
              }
              if (r.is_examine == 0) {
                v.iswrong = 1;
                return;
              }
              if(!r.exif.width) r.exif.width=350
              if(!r.exif.height) r.exif.height=480
              v.cid = v.activityId
            })
            //展示第一张图片并压缩
            if (this.draftinfo.type == 2) {
              v.comurl = v.images[0].url + '?vframe/jpg/offset/1/w/' + v.images[0].exif.width + '/h/' + v.images[0].exif.height;
            } else {
              if (this.draftinfo.type == 3) {
                if (v.images[0].exif.type == 2) {
                  v.comurl = v.images[0].url + '?vframe/jpg/offset/1/w/' + v.images[0].exif.width + '/h/' + v.images[0].exif.height;
                } else {
                  if (Number(v.images[0].size) > 20 * 1024 * 1024) {
                    v.comurl = v.images[0].url;

                  } else {
                    v.comurl = v.images[0].url + '?imageMogr2/format/webp/thumbnail/750x/quality/100!/ignore-error/1';
                  }
                }
              } else {
                if (this.draftinfo.type == 5) {
                  v.comurl = 'https://qn002.pfotoo.com/file/' + v.images[0].exif.mark + '.svg';
                } else {
                  if (Number(v.images[0].size) > 20 * 1024 * 1024) {
                    v.comurl = v.images[0].url;

                  } else {
                    v.comurl = v.images[0].url + '?imageMogr2/format/webp/thumbnail/750x/quality/100!/ignore-error/1';
                  }
                }
              }
            }
          }

          if(i%3==0){
            v.bg='bg-blue'
          }
          if(i%3==1){
            v.bg='bg-yellow'
          }
          if(i%3==2){
            v.bg='bg-pink'
          }
          if(v.images && v.images.length>0){
            v.images.forEach((r,n)=>{
              v.isselect=false;
              if(typeof r.exif=='string'){
                r.exif=JSON.parse(r.exif)
              }
              v.action=false;
              if(r.exif.width){
                r.width=Number(r.exif.width);
                r.height=Number(r.exif.height);
              }
              if(this.draftinfo.type==2){
                r.comurl=r.url+'?vframe/jpg/offset/1/w/'+r.width+'/h/'+r.height;
              }else{
                if(this.draftinfo.type==3){
                    if(r.exif.type==2){
                      r.comurl=r.url+'?vframe/jpg/offset/1/w/'+r.width+'/h/'+r.height;
                    }else{
                      r.comurl=r.url+'?imageMogr2/thumbnail/1000x/quality/100';
                    }
                }else{
                  if(this.draftinfo.type==5){
                    console.log('rrrrr','fffffffff')
                    r.width=200;
                    r.height=240;
                  	r.comurl='https://assets.pfotoo.com/file/'+r.exif.mark+'.svg';
                  }else{
                    if(this.draftinfo.type==4){
                      // console.log()
                      // let text=r.exif.text.replace(/ /ig,"&nbsp;");
                      // r.exif.text=text;
                    }else{
                      r.comurl=r.url+'?imageMogr2/thumbnail/1000x/quality/100';
                    }

                  }
                }
                if(n==0){
                  //宽度为准
                  if(r.width*240/200>=r.height){
                    let showheight=r.height*200/r.width;
                    v.bottom=(240-showheight)/2+10;
                    v.right=10
                  }else{
                    let showwidth=240*r.width/r.height;
                    v.right=(200-showwidth)/2+10;
                    v.bottom=10;
                  }
                }
              }
            })
          }
          if(this.allselect){
            this.allselect=false;
          }
        })
        if(this.listconfig[this.type].page==1){
          this.showlist=json;
        }else{
          this.showlist=this.showlist.concat(json)
        }
        console.log(this.showlist)
      }else{
        if(this.listconfig[this.type].page==1){
          this.showlist=[];
        }
        this.listconfig[this.type].end=true;
      }
      this.listconfig[this.type].loaded=true;
     },
     editaction(obj){
      let id=obj.id,index=obj.index;
      let showlist=this.showlist;
      showlist.forEach((v,i)=>{
        if(v.action){
          this.showlist[i].action=false;
          this.$set(v,'action',false);
        }
      })
      this.showlist[index].action=true;
      this.$set(this.showlist[index],'action',true);
      console.log(this.showlist)
     },
     changeshowlist(){
       let showlist=this.showlist;
       showlist.forEach((v,i)=>{
         if(v.action){
           this.showlist[i].action=false;
           this.$set(v,'action',false);
         }
       })
     },
     selectunit(index){
       this.unitlist.forEach((v,i)=>{
          if(index==i){
            console.log('selectunit',v.isactive)
            v.isactive=!v.isactive;
            this.unitlist[i].isactive=v.isactive;
            this.unit=v.isactive ? v.name : '';
            this.listconfig[this.type]={
              id:this.groupid && this.groupid!=0 ? this.groupid : this.id,
              page:1,
              end:false,
              loaded:false
            }
            this.getnewlist();
          }else{
            v.isactive=false;
            this.unitlist[i].isactive=false;
          }

        })
     },
      selectMaterialType(MaterialType){
       if(this.activeMaterialType==MaterialType){
         this.activeMaterialType=''
       }else{
         this.activeMaterialType=MaterialType
       }
        this.listconfig[this.type]={
          id:this.groupid && this.groupid!=0 ? this.groupid : this.id,
          page:1,
          end:false,
          loaded:false
        }
        this.getnewlist();
      },
      selectTrackId(TrackId){
        if(this.activeTrackId==TrackId){
          this.activeTrackId=''
        }else{
          this.activeTrackId=TrackId
        }
        this.listconfig[this.type]={
          id:this.groupid && this.groupid!=0 ? this.groupid : this.id,
          page:1,
          end:false,
          loaded:false
        }
        this.getnewlist();
      },
     handleScroll(){
       console.log('rrrr')
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        console.log(scrollTop)
        if(this.showlist.length>0){
          if($('.work-single').length>0){
            let lasttop=$('.work-single').eq(this.showlist.length-1).offset().top;
            console.log(lasttop,'llllll')
            if(scrollTop>=lasttop-window.innerHeight && !this.listconfig[this.type].end && this.listconfig[this.type].loaded){
              this.listconfig[this.type].loaded=false;
              this.listconfig[this.type].page+=1;
              this.getnewlist();

            }
          }

        }
     },
     selectsingle(obj){
       //let submissionId=obj.submissionId,index=obj.index;
       //let showlist=this.showlist;
       this.selectids=this.selectids.filter((item,index)=>{
         return item!=obj.submissionId
       })
       if(obj.checked){
         this.selectids.push(obj.submissionId)
       }
       //this.allselect=this.selectids.length==this.showlist.length;
     },
     selectall(){
       this.allselect=!this.allselect;
       this.$refs.work.forEach(work=>{
         work.selectsingle(this.allselect)
       })
     },
     //邀请投稿
     invite(id){
      this.$http({
        url:'https://pfotoo.com?s=App.User.PcShareQrcode'+this.$getsign(),
        params:{
          id:id,
        },
        method:'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        console.log(res.body)
        let json=res.body;
        if(res.body.ret==200){
            this.code=json.data;
            this.showcode="visible";
            this.showtype='invite';
        }
      })
     },
     closecode(){
      this.showcode="hidden";
     },
     getallimages(){
       this.showimages=[];
        this.showlist.forEach((v,i)=>{
          if(v.materialList.length>0){
              v.materialList.forEach((r,n)=>{
                console.log(r)
                r.left=0;
                r.name=v.name;
                r.cid=v.id
                this.showimages.push(r)
              })
          }
        })
     },
     showbigimages(index){
       this.$refs.proview.setIndex(0)
       this.$refs.proview.show(this.showlist[index])
     },
     previmage(){
        console.log()
        if(this.showindex>=1){
          if(this.draftinfo.type==2){
            $('#video'+this.showimages[this.showindex].id)[0].pause();
          }else{
            if(this.draftinfo.type==3){
              if(this.showimages[this.showindex].exif.type==2){
                $('#video'+this.showimages[this.showindex].id)[0].pause();
              }
            }
          }
          this.showindex--;
          if(this.draftinfo.type==2){
            $('#video'+this.showimages[this.showindex].id)[0].play();
          }
          if(this.draftinfo.type==3){
            if(this.showimages[this.showindex].exif.type==2){
              $('#video'+this.showimages[this.showindex].id)[0].play();
            }
          }
          // if(this.showimages[this.showindex-1].exif==2){
          //   $('#video'+this.showimages[this.showindex-1].id)[0].play();
          // }
          this.showimages[this.showindex].left=0;
          this.showimages[this.showindex+1].left='100%';
        }
     },
     nextimage(){
       if(this.showindex<this.showimages.length-1){
         if(this.draftinfo.type==2){
           $('#video'+this.showimages[this.showindex].id)[0].pause();
         }else{
           if(this.draftinfo.type==3){
             if(this.showimages[this.showindex].exif.type==2){
               $('#video'+this.showimages[this.showindex].id)[0].pause();
             }
           }
         }
         this.showindex++;
         if(this.draftinfo.type==2){
           $('#video'+this.showimages[this.showindex].id)[0].play();
         }
         if(this.draftinfo.type==3){
           if(this.showimages[this.showindex].exif.type==2){
             $('#video'+this.showimages[this.showindex].id)[0].play();
           }
         }
         this.showimages[this.showindex].left=0;
         this.showimages[this.showindex-1].left='-100%';
       }
     },
     delwork(){
       if(![0,1].includes(this.identityType)) {
         return this.$message({
           showClose: true,
           message: App.identityTypes(this.identityType)+'无操作权限',
           type: 'error',
         });
       }
        if(this.selectids.length>0){
          this.$confirm('此操作将永久删除该投稿, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.delrealwork();
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
            this.canelselect();

          });
        }else{
          this.$message({
              showClose: true,
              message: '请选择要删除的投稿'
          });
        }
     },
     canelselect(){
       this.showlist.forEach((v,i)=>{
         if(v.isselect==true){
           v.isselect=false;
         }
       })
     },
     delrealwork(){
       let params={
         submissionIdList:this.selectids
       }
      this.$http({
        url:'https://pfotoo.com?s=App.Works.DelWorks'+this.$getsign(),
        params:params,
        method:'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==200){
          this.$message({
             message: '删除成功',
             type: 'success'
         });
         this.selectids=[];
         this.strselectids='';
         this.showlist=[];
         this.listconfig[this.type]={
           id:this.listconfig[this.type].id,
           page:1,
           end:false,
           loaded:false
         }
          this.getnewlist();
        }
      })
     },
     sethidework(status){
       if(this.selectids.length>0){
         let params={
           "status": status,
           "submissionIdList": this.selectids
         }
         this.$http({
           url:'https://pfotoo.com?s=App.Contribution.SetEventHide'+this.$getsign(),
           params:params,
           method:'POST',
           headers: {
             'Content-Type': 'application/x-www-form-urlencoded'
           }
         }).then((res)=>{
           if(res.code==200){
             this.getnewlist();
              this.$message({
                  message: '投稿已'+(status==1?'隐藏':'显示'),
                  type: 'success'
              });
           }
         })
       }
      },
     download(){
       if(this.selectids.length>5){
         this.$message({
             showClose: true,
             message: '单次下载最多不能超过5个投稿'
         });
       }else{
         this.$message({
             showClose: true,
             message: '请选择投稿'
         });
       }
     },
     close(){
       console.log('this.$refs.video',this.$refs.video)
       if(this.$refs.video && this.$refs.video.length>0){
         this.$refs.video.forEach(video=>{
           video.pause()
         })
       }
       if(this.$refs.audio && this.$refs.audio.length>0){
         this.$refs.audio.forEach(audio=>{
           audio.pause()
         })
       }
       this.showcover='hidden';
     },
      back(){
        this.$router.back();//返回上一层
      },
      //tab相册通知事件
      tellgroup(obj){
        console.log('dddd',obj);
        this.type=obj.type;
        this.groupid=obj.groupid;
        this.listconfig[this.type]={
          id:obj.groupid!=0 ? obj.groupid : this.id,
          page:1,
          end:false,
          loaded:false
        }
        this.selectids=[];
        this.strselectids='';
        this.workidstr='';
        this.showlist=[];
        this.getnewlist();
      },
      refresh(){
        this.selectids=[];
        this.strselectids='';
        this.showlist=[];
        this.listconfig[this.type]={
          id:this.listconfig[this.type].id,
          page:1,
          end:false,
          loaded:false
        }
        this.getnewlist();
      },
      downall(){
        this.$router.push({
          path:'/pay'
        })
      },
      downloadFile(){
        console.log('downloadFile',this.showimages[this.showindex],this.showlist)
        if(this.draftinfo.type==4){
          let createInput = document.createElement("input");
          createInput.value = this.showimages[this.showindex].exif.text;
          document.body.appendChild(createInput);
          createInput.select(); // 选择对象
          document.execCommand("Copy"); // 执行浏览器复制命令
          createInput.style.display = "none";
          this.$message({ message: "复制成功", type: "success" });
          return
        }
        let workdata,suffix=''
          ,fileName=this.showimages[this.showindex].id
          ,url=this.showimages[this.showindex].url
        this.showlist.some(work=>{
          if(work.id==this.showimages[this.showindex].cid){
            workdata=work
            //console.log('downloadFile',work)
            return true;
          }
        })
        if(workdata){
          fileName=(workdata.autograph||workdata.wechatNickName||workdata.userName)
        }
        if(this.showimages[this.showindex].exif.suffix){
          suffix='.'+this.showimages[this.showindex].exif.suffix
        }else{
          if(this.showimages[this.showindex].exif.type==1){
            suffix='.jpg'
          }
          if(this.showimages[this.showindex].exif.type==2){
            suffix='.mp4'
          }
        }
        fileName+=suffix
        if(/(\.jpg)|(\.jpeg)|(\.png)|(\.bmp)|(\.gif)/g.test(fileName)){
          url+='?imageMogr2/format/webp/thumbnail/750x/quality/100!/ignore-error/1'//缩略图
        }
        App.download(url,fileName)
      },
      optionPlaneEvent(e){
        console.log('optionPlaneEvent',e)
        this.params=e.params
        this.getnewlist()
      },
      handleSizeChange(pageSize){
        this.pageSize=pageSize
        this.handleCurrentChange(1)
      },
      handleCurrentChange(val){
        this.pageIndex=val;
        this.getnewlist();
      },
      queryUserIdentityType(){
        App.demand('/activity/queryUserIdentity','GET',{activityId:this.id}).then(res=>{
          this.identityType=res.data.identityType
        })
      },
    },
    mounted(){
      console.log(this.$route.params.id,'yyyyyy')
      this.id=this.$route.params.id;
      this.getdetail();
      this.queryUserIdentityType()
      this.params={
        activityId: this.id,
        pageIndex: 1,
        pageSize: this.pageSize,
        orderOption:'',
      }
      this.getnewlist();
      //window.addEventListener('scroll', this.handleScroll)
    },

  }
</script>

<style>
  .detail-top {
      width: 100%;
      padding: 0px 30px 80px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
  }
  .detail-active-title{
    padding: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;
    margin-bottom: 10px;
  }
  .checkbox {
      width: 16px;
      height: 16px;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      margin-right: 6px;
      cursor: pointer;
  }
  .code-mask{
    background: rgba(0,0,0,.85);
    z-index: 100;
  }
  .code-content {
      width: 450px;
      height: 450px;
      border-radius: 10px;
      padding: 40px 0 50px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
  }
  .invite-code {
      width: 215px;
      height: 215px;
      margin: 30px 0;
  }
  .code-close {
      position: absolute;
      right: 30px;
      top: 30px;
      cursor: pointer;
  }
  .detail-unit-list {
      padding-top: 18px;
  }
  .detail-unit-single {
      margin-right: 30px;
      margin-bottom: 10px;
      line-height: 20px;
      padding: 5px 0;
      cursor: pointer;
      font-weight: 500;
  }
  .unit-green-font {
      border-bottom: 1px solid #3dc4a7;
  }
  .work-cover {
      background: rgba(0,0,0,.8);
      z-index: 100;
  }
  .work-cover-top {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 60px;
      padding: 0 40px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      background: #1a2e3b;
      z-index: 2;
  }
  .work-cover-top img {
      width: 24px;
      height: 24px;
      cursor: pointer;
  }
  .down-load-hover {
      width: 44px;
      height: 25px;
      position: absolute;
      top: 50px;
      left: -10px;
      border-radius: 4px;
      background: rgba(0,0,0,.6);
      display: none;
      text-align: center;
      line-height: 25px;
  }
  .download-icon:hover .down-load-hover{
      display: block;
  }
  .download-icon {
      display: block;
      position: relative;
  }
  .swiper-container {
      width: 94%;
      height: 100%;
      position: relative;
      margin: 0 auto;
  }
  .swiper-wrapper {
      position: absolute;
      left: 0;
      top: 60px;
      bottom: 0;
      width: 100%;
      overflow: hidden;
  }
  .swiper-slide {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      -webkit-transition: left .4s ease-in .1s;
      transition: left .4s ease-in .1s;
  }
  .swiper-bg {
      width: 90%;
      height: 96%;
  }
  .swiper-button {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      width: 40px;
      height: 100%;
      cursor: pointer;
  }
  .swiper-button-prev {
      left: 0;
  }
  .swiper-button-next {
      right: 0;
  }
  .swiper-button img {
      width: 25px;
  }
  .work-hide{
    padding: 0 5px;
    line-height: 20px;
    position: absolute;
    left:0;
    top:0;
    background: rgba(0,0,0,.5);
  }
  .work-font-cover{
    padding:50px;
    box-sizing: border-box;
    white-space:pre-wrap;
    background: radial-gradient(circle, #1a2e3b, #353535);
    /* overflow-y: scroll; */
  }
  .search{
    height: 36px;
    border-radius: 5px;
    background: #F2F2F3;
    margin-right: 20px;
  }
  .search-input{
      width: 100px;
      height: 100%;
      outline: none;
      transition: width ease .3s;
      background: transparent;
      padding: 0 5px;
      border: 0;
      box-sizing: border-box;
      line-height: 36px;
      font-size: 14px;
      margin-right: 5px;
  }
    .search-button{
    padding: 0 10px;
    height: 100%;
  }
  .search-button img{
    width: 15px;
    height: 16px;
  }
  /* .work-font-content{
    width: 100%;
    height: 100%;
  } */
  .swiper-bg-audio{
    display: flex;
    flex-direction: column;
    justify-content:center;
    align-items:center;
  }
  .audio-bg{
    width: 200px;
    height: 200px;
    box-shadow: 0px 1px 4px 1px #9cc5ad;
    border-radius: 50%;
    background-size: cover;
  }
  .detail-page{
    position: fixed;
    bottom: 0px;
    left:230px;
    z-index: 99;
    padding: 8px 20px;
    width: 100%;
    box-sizing: border-box;
  }
</style>


// WEBPACK FOOTER //
// src/components/list/detail.vue